<template>
  <v-dialog v-model="openFiltersDialog" max-width="1000px" persistent>
    <div class="filters-container">
      <v-container>
        <v-row justify="space-between">
          <h1 class="filters-title">
            {{ $t('filter.title') }}
          </h1>
          <v-btn color="secondary" icon @click="closeDialog">
            <v-icon>mdi-window-close</v-icon>
          </v-btn>
        </v-row>
        <div class="data-loading" v-if="loadingFilters">
          <v-progress-circular
            :size="70"
            :width="7"
            color="blue"
            indeterminate
          ></v-progress-circular>
        </div>
        <div v-else>
          <v-row>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="selectedFilters.country"
                :items="getArrayFromObject(filters.country)"
                :label="countryText"
                hide-details
                multiple
                :hide-no-data="true"
                autocomplete="disabled"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="selectedFilters.city"
                :items="cityFilters"
                :label="cityText"
                item-text="value"
                item-value="value"
                hide-details
                multiple
                :hide-no-data="true"
                autocomplete="disabled"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="selectedFilters.firstLanguage"
                :items="getArrayFromObject(filters.firstLanguage, true)"
                :label="nativeLangText"
                hide-details
                multiple
                :hide-no-data="true"
                autocomplete="disabled"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="selectedFilters.secondLanguage"
                :items="getArrayFromObject(filters.secondLanguage, true)"
                :label="secondLangText"
                hide-details
                multiple
                :hide-no-data="true"
                autocomplete="disabled"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="selectedFilters.professions"
                :items="getArrayFromObject(filters.professions, true)"
                :label="professionText"
                hide-details
                multiple
                :hide-no-data="true"
                autocomplete="disabled"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="selectedFilters.postGrades"
                :items="getArrayFromObject(filters.postGrades, true)"
                :label="postgradeText"
                hide-details
                multiple
                :hide-no-data="true"
                autocomplete="disabled"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="selectedFilters.specialties"
                :items="getArrayFromObject(filters.specialties, true)"
                :label="specialtyText"
                hide-details
                multiple
                :hide-no-data="true"
                autocomplete="disabled"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="selectedFilters.subSpecialties"
                :items="getArrayFromObject(filters.subSpecialties, true)"
                :label="subSpecialtyText"
                hide-details
                multiple
                :hide-no-data="true"
                autocomplete="disabled"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="selectedFilters.expertices"
                :items="getArrayFromObject(filters.expertices, true)"
                :label="experticeText"
                hide-details
                multiple
                :hide-no-data="true"
                autocomplete="disabled"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="selectedFilters.profiles"
                :items="getArrayFromObject(filters.profiles, true)"
                :label="profileText"
                hide-details
                multiple
                :hide-no-data="true"
                autocomplete="disabled"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="selectedFilters.cientificAs"
                :items="getArrayFromObject(filters.cientificAs)"
                :label="associationsText"
                hide-details
                multiple
                :hide-no-data="true"
                autocomplete="disabled"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="selectedFilters.courseG"
                :items="getArrayFromObject(filters.courseG, true)"
                :label="courseGEText"
                hide-details
                multiple
                :hide-no-data="true"
                autocomplete="disabled"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="selectedFilters.category"
                :items="getArrayFromObject(filters.category, true, false)"
                :label="categoryText"
                hide-details
                multiple
                :hide-no-data="true"
                autocomplete="disabled"
              />
            </v-col>
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="selectedFilters.unities"
                :items="getArrayFromObject(filters.unities, true, false)"
                :label="unityText"
                hide-details
                multiple
                :hide-no-data="true"
                autocomplete="disabled"
              />
            </v-col>
            <v-col cols="12" md="6" v-if="isSuper">
              <v-menu
                v-model="rangeDatePicker"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dateRangeLabel"
                    :label="endContractDateText"
                    append-icon="mdi-calendar"
                    clearable
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    hide-details
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="selectedFilters.endContract"
                  no-title
                  range
                  scrollable
                  :locale="locale"
                />
              </v-menu>
            </v-col>
          </v-row>
        </div>

        <v-divider class="mt-4 mb-2"></v-divider>
        <v-row justify="center">
          <v-btn class="mr-4 mt-4" @click="closeDialog">
            {{ $t('common.close') }}
          </v-btn>
          <v-btn @click="clearFilters" color="secondary" class="mr-4 mt-4">
            {{ $t('admin.clearFilters') }}
          </v-btn>
          <v-btn
            @click="applyFilters"
            color="primary"
            :disabled="applyingFilters"
            class="mt-4"
          >
            <span v-if="applyingFilters"
              ><v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular
            ></span>
            <span v-else>{{ $t('filter.applyFilters') }}</span>
          </v-btn>
        </v-row>
      </v-container>
    </div>
  </v-dialog>
</template>

<script>
//import _clone from 'lodash/clone'
import { auth } from '../firebase'
import { mapState } from 'vuex'
import {
  getVisibleValue,
  getDateFromTimestamp,
  getDateFromString,
  getPublicationInfo,
  getArrayFromObject,
  getArrayFromObjectList
} from '@/utils/common'
import { isUserSuper } from '@/consts/common'

export default {
  data: () => ({
    selectedFilters: {},
    rangeDatePicker: false,
    locale: localStorage.getItem('bd-kol-lang') || 'es',
    isSuper: isUserSuper(auth.currentUser.email)
  }),
  watch: {
    dirtyFilters(newVal) {
      if (!newVal) {
        this.initFilters()
      }
    }
  },
  created() {
    this.initFilters()
  },
  computed: {
    ...mapState({
      openFiltersDialog: state => state.leaderStore.openFiltersDialog,
      loadingFilters: state => state.leaderStore.loadingFilters,
      filters: state => state.leaderStore.filters,
      dirtyFilters: state => state.leaderStore.dirtyFilters,
      applyingFilters: state => state.leaderStore.applyingFilters
    }),
    cityFilters() {
      const allCities = getArrayFromObjectList(this.filters.city)
      const selectedCountries = this.selectedFilters.country
      return selectedCountries.length
        ? allCities.filter(c => selectedCountries.includes(c.country))
        : allCities
    },
    dateRangeLabel: {
      get() {
        const endContract = this.selectedFilters?.endContract
        let value = []
        if (endContract?.length) {
          value = getDateFromString(endContract[0])
        }
        if (endContract?.length === 2) {
          value += ' ~ ' + getDateFromString(endContract[1])
        }
        return value
      },
      set(range) {
        this.selectedFilters.endContract = range ? range : []
        return range
      }
    },
    countryText() {
      return this.$t('fields.country')
    },
    cityText() {
      return this.$t('fields.city')
    },
    professionText() {
      return this.$t('fields.profession')
    },
    postgradeText() {
      return this.$t('reg.postgrade')
    },
    specialtyText() {
      return this.$t('fields.specialty')
    },
    subSpecialtyText() {
      return this.$t('fields.subSpecialty')
    },
    experticeText() {
      return this.$t('reg.expertice')
    },
    profileText() {
      return this.$t('fields.profile')
    },
    associationsText() {
      return this.$t('reg.associations')
    },
    nativeLangText() {
      return this.$t('reg.nativeLang')
    },
    secondLangText() {
      return this.$t('reg.secondLang')
    },
    courseGEText() {
      return this.$t('reg.courseGE')
    },
    categoryText() {
      return this.$t('fields.category')
    },
    unityText() {
      return this.$t('fields.unity')
    },
    endContractDateText() {
      return this.$t('fields.endContractDate')
    }
  },
  methods: {
    getDateFromTimestamp: getDateFromTimestamp,
    getVisibleValue: getVisibleValue,
    getPublicationInfo: getPublicationInfo,
    getArrayFromObject: getArrayFromObject,
    getDateFromString: getDateFromString,
    closeDialog() {
      this.$store.dispatch('leaderStore/openFiltersDialog', false)
    },
    applyFilters() {
      this.$store.dispatch('leaderStore/applyFilters', {
        selected: this.selectedFilters
      })
    },
    clearFilters() {
      this.$store.dispatch('leaderStore/clearFilters')
      this.initFilters()
    },
    initFilters() {
      this.selectedFilters = {
        country: [],
        city: [],
        professions: [],
        postGrades: [],
        specialties: [],
        subSpecialties: [],
        expertices: [],
        profiles: [],
        cientificAs: [],
        firstLanguage: [],
        secondLanguage: [],
        courseG: [],
        category: [],
        unities: [],
        endContract: []
      }
    }
  }
}
</script>
<style lang="scss">
.filters-container {
  display: flex;
  justify-content: center;
  background-color: #fff;
  padding: 20px;
  word-break: break-word;

  .filters-title {
    text-align: left;
    color: #2e478d;
    font-size: 22px;
    padding-left: 10px;
  }
  .data-loading {
    margin: 40px auto;
    width: 70px;
  }
}
</style>
